import type { Price, ProductPrices } from '../../types';
import type { DesignProduct } from '../presenter/types';

export const getPriceForProduct = (
    product: DesignProduct,
    productPrices?: ProductPrices
): Price | undefined => {
    if (!productPrices || productPrices.length === 0) {
        return undefined;
    }

    const productPrice = productPrices.find(
        (productPrice) =>
            productPrice.service.mpvId === product.mpvId ||
            productPrice.print?.mpvId === product.mpvId
    );

    if (!productPrice) {
        return undefined;
    }

    return {
        currency: productPrice.currency,
        listPrice: {
            taxed: productPrice.listPrice.taxed,
            untaxed: productPrice.listPrice.untaxed,
        },
    };
};
